import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import * as Constants from '../../constants'

export function FeaturedSection() {
  return (
    <section className="py-8 lg:py-12 bg-white dark:bg-gray-900 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        <div className="mb-8">
          <p className="text-sm text-gray-600 dark:text-gray-400 uppercase tracking-wider mb-2">FEATURED SERVICES</p>
          <h2 className="text-3xl lg:text-4xl text-blue-900 dark:text-blue-300 max-w-3xl">
            Digital services with no paperwork required—that's Lagos State Digital Court
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={`${Constants.baseurl}/assets/landing_images/JIS-Court.png`}
              alt="Digital Court Services"
              className="w-full h-96 object-cover rounded-lg"
            />
          </div>
          
          <div className="space-y-6">
            <h3 className="text-2xl text-blue-900 dark:text-blue-300">
              How Much Legal Support Can You Access?
            </h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Here's what to consider when calculating your legal service options and understanding 
              the digital transformation of our court system.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-blue-900 dark:text-blue-300 mb-1">24/7 Digital Access</h4>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">File documents and access services anytime</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-blue-900 dark:text-blue-300 mb-1">Faster Processing</h4>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">Reduced waiting times with digital workflows</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-blue-900 dark:text-blue-300 mb-1">Transparent Tracking</h4>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">Monitor your case status in real-time</p>
                </div>
              </div>
            </div>
            <Button className="bg-orange-500 hover:bg-orange-600 text-white">
              Learn More
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}